'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { publishEvent } from '@udemy-v2/event-tracking';
import { BuyNowEvent, EnrollNowEvent, LearningProduct } from '../events/events';
import { useClpCourse } from '../context/clp-course-provider.react-component';
import { useClcBuyButtonContext } from '@/lib/hooks/use-clc-buy-button-context';
import { BuyButtonState } from '@/features/course-landing-page/hooks/use-clp-primary-cta-button';

/**
 * Builds the CLP primary CTA state for authenticated organization members.
 *
 * Text, URL, style, and event type are sourced directly from the monolith's
 * `buy_button.button` payload (get_buy_button_context in
 * udemy/course_landing_page/helpers.py) so business logic stays on the
 * backend. The hook is a thin passthrough plus event wiring.
 */
export function useOrgPrimaryCtaButton() {
  const $ = _c(11);
  const course = useClpCourse();
  const org = useClcBuyButtonContext();
  const t0 = Number(course.id);
  const t1 = course.frontendTrackingId || course.id;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      buyable: {
        id: t0,
        type: LearningProduct.COURSE,
        trackingId: t1
      }
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const eventPayload = t2;
  let t3;
  bb0: {
    if (!org) {
      let t4;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
          checkoutUrl: "",
          trackEvent: _temp,
          isLoading: true as const
        };
        $[3] = t4;
      } else {
        t4 = $[3];
      }
      t3 = t4;
      break bb0;
    }
    let t4;
    if ($[4] !== eventPayload || $[5] !== org.event_type) {
      t4 = () => {
        switch (org.event_type) {
          case "enroll_now":
            {
              publishEvent(new EnrollNowEvent(eventPayload));
              return;
            }
          case "buy_now":
            {
              publishEvent(new BuyNowEvent(eventPayload));
              return;
            }
          default:
            {
              return;
            }
        }
      };
      $[4] = eventPayload;
      $[5] = org.event_type;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    const trackEvent = t4;
    const t5 = org.buy_url ?? "";
    let t6;
    if ($[7] !== org.text || $[8] !== t5 || $[9] !== trackEvent) {
      t6 = {
        text: org.text,
        checkoutUrl: t5,
        trackEvent,
        isLoading: false as const,
        udStyle: "secondary"
      };
      $[7] = org.text;
      $[8] = t5;
      $[9] = trackEvent;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t3 = t6;
  }
  return t3;
}
function _temp() {}